import React from "react";
import {
  CoverageDetailsCard,
  EnrolmentContent,
  ProductFooter,
} from "../styles";
import { Ptag } from "components/core";
import useFetchEndorsementBrief from "../useFetchEndorsementBrief";
import { addLeadingZero, formatDateReverse } from "utlis/utils";
import BaseLinkButton from "components/core/BaseLinkButton";

function EndorsementCard({ userplanId }) {
  const { endorsementBrief, loading } = useFetchEndorsementBrief({
    userplanId,
  });

  return (
    <CoverageDetailsCard style={{ gridColumn: "1/3" }}>
      <header
        style={{
          display: "flex",
          alignItems: "flex-end",
          marginBottom: "14px",
          gap: "6px",
        }}
      >
        <Ptag fontSize="18px">Enrolments</Ptag>
        {endorsementBrief?.last_endorsement_date && (
          <Ptag color="#6E6097" fontSize="14px">
            (as on {formatDateReverse(endorsementBrief?.last_endorsement_date)})
          </Ptag>
        )}
      </header>
      <EnrolmentContent>
        <div>
          <Ptag color="#646075" fontWeight="400" marginBottom="8px">
            Additions
          </Ptag>
          <Ptag fontWeight="700" fontSize="20px">
            {addLeadingZero(endorsementBrief?.total_lives_added) || "-"}
          </Ptag>
        </div>
        <div>
          <Ptag color="#646075" fontWeight="400" marginBottom="8px">
            Deletions
          </Ptag>
          <Ptag fontWeight="700" fontSize="20px">
            {addLeadingZero(endorsementBrief?.total_lives_deleted) || "-"}
          </Ptag>
        </div>
      </EnrolmentContent>
      <ProductFooter>
        <BaseLinkButton label="View All" path="/v1/enrolments" />
      </ProductFooter>
    </CoverageDetailsCard>
  );
}

export default EndorsementCard;
